import React from "react";
const Footer = () => {
  return (
    <small
      style={{
        margin: "0px",
        position: "fixed",
        bottom: "0%",
        left: "50%",
        transform: "translate(-50%, 0%)",
        textAlign: "center",
      color:"white",
        width: "100%",
        padding: "10px",
        fontSize: "13px",
        zIndex: 100,
      }}
    >
      <a
        href="https://rbhardwaj.com/"
        target="_blank"
       style={{color:"white",textDecoration:"none"}}
      >
        ©2026 Face Attendance Powered by <b><i>Rahul Sharma</i></b>
      </a>
    </small>
  );
};

export default Footer;